module.exports = __webpack_public_path__ + "img/hero.47c81b73.jpg";